import { render, staticRenderFns } from "./GuanoComponent.vue?vue&type=template&id=f805c984&"
import script from "./GuanoComponent.vue?vue&type=script&lang=js&"
export * from "./GuanoComponent.vue?vue&type=script&lang=js&"
import style0 from "./GuanoComponent.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports